import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getAllAccountsForBulkUpdate(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("refreshPortfolioForClientAccounts", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    previewAccountBulkUpdate(ctx, data) {
      // Sends all four values so the server can compute AccountCode change previews.
      return new Promise((resolve, reject) => {
        axiosIns
          .post("previewAccountBulkUpdate", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    confirmAccountBulkUpdate(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("confirmAccountBulkUpdate", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
